<template>
  <v-row class="justify-center">
    <v-col
      v-for="product in products"
      :key="product._id"
      cols="12"
      sm="4">
      <v-card
        class="pa-4 text-center"
        hover
        :disabled="disabled"
        v-bind="activeProps(product.packageMonth)"
        @click="updatePackageMonth(product.packageMonth)">
        <div class="text-capitalize font-weight-bold _fs-36">
          {{ product.packagePlan }}
          <span :class="{ 'primary--text': !isPackageMonthSelect(product.packageMonth) }">
            {{ product.packageMonth }} เดือน
          </span>
        </div>

        <img
          class="my-4"
          :src="`/svg/package-${product.packageMonth}m.svg`">

        <div
          class="font-weight-bold _fs-36"
          :class="{ 'primary--text': !isPackageMonthSelect(product.packageMonth) }">
          {{ product.unitPrice | numberComma }} บาท
        </div>

        <div
          class="_fs-14"
          :class="{ 'error--text': !isPackageMonthSelect(product.packageMonth) }">
          * ราคาดังกล่าวไม่รวมภาษีมูลค่าเพิ่ม 7%
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'OrderPackageMonthProduct',
  props: {
    products: {
      type: Array,
      default: () => []
    },
    packageMonth: {
      type: Number,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updatePackageMonth (value) {
      this.$emit('update:package-month', value)
    },
    isPackageMonthSelect (value) {
      return this.packageMonth === value
    },
    activeProps (value) {
      if (this.isPackageMonthSelect(value)) {
        return {
          dark: true,
          color: 'primary',
          style: { opacity: '0.7' }
        }
      }

      return {}
    }
  }
}
</script>
